<div class="closeButton" >
    <button mat-icon-button [mat-dialog-close]="true">
        <mat-icon>close</mat-icon>
    </button>
</div>
<form #f="ngForm" (ngSubmit)="onSubmitSuche(f.suche)">
  <mat-form-field class="filterFollowingUserInput" >
      <div matSuffix>
          <mat-icon>search</mat-icon>
      </div>
    <input matInput
           placeholder="{{'keyword_$4' | translate}}"
           [(ngModel)]="value"
           #searchbox
           (onchange)="_filterLen(value)"
           autocomplete="off"
           [formControl]="searchValue">
           <mat-hint align="start">{{board_name}} {{'keyword_$236' | translate}} <strong>{{boardFollowerCount}}</strong> {{'keyword_$130' | translate}} </mat-hint>
  </mat-form-field>
</form>
<br>
<div class="followerList" *ngFor="let follower of filteredStates | async">
    <mat-card>
        <mat-card-header>
            <div mat-card-avatar (click)="closeBottomSheet()" routerLink="p/{{follower.user_name}}" class="followerListUserAvatar" [ngStyle]="{'background': 'linear-gradient(0deg, rgba(0, 0, 0, 0.5),
            rgba(0, 0, 0, 0.5)), url(' + follower.user_avatar + ')
            center center / cover no-repeat'}">
            </div>
            <mat-card-title>{{follower.user_name}}
                <span *ngIf="follower.user_is_verified == 1">
                    <mat-icon class="verifiedSmall">verified</mat-icon>
                </span>
            </mat-card-title>
            <mat-card-subtitle *ngIf="follower.user_city != null"> {{'keyword_$218' | translate}} {{follower.user_city}}</mat-card-subtitle>
            <mat-card-subtitle *ngIf="follower.user_city == null"> {{'keyword_$238' | translate}} </mat-card-subtitle>
            <span class="example-fill-remaining-space"></span>
            <button mat-button routerLink="p/{{follower.user_name}}" (click)="closeBottomSheet()">
                {{'keyword_$237' | translate}}
            </button>
        </mat-card-header>
    </mat-card>
</div>
